import { TemplateRef } from '@angular/core';
import { BasicDataType, OrderPermission } from 'src/app/shared/interface/common.interface';

export interface OrderTableColConfig {
  dataKey: string;
  columnName: string;
  isEnabled: boolean;
  dataType: BasicDataType;
  textAlign: 'start' | 'center' | 'end';
}

export interface OrderListData {
  [key: string]: any;
  status: OrderStatus;
  actionList: OrderActionType[];
}

export enum OrderActionType {
  view = 'view',
  edit = 'edit',
  copy = 'copy',
  transfer = 'transfer',
  download = 'download',
}

export enum OrderStatus {
  inProgress = 'IN_PROGRESS',
  completed = 'COMPLETED',
  expired = 'EXPIRED',
  automated = 'PENDING_AUTOMATION',
  paymentFailed = 'PAYMENT_FAILED',
  draft = 'DRAFT',
}

export interface OrderListFilter {
  companyKey?: string;
  ownedUsername?: string | null;
  reportType?: string | null;
  status?: string | null;
  createdDate?: {
    from: Date | null;
    to: Date | null;
  };
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  address?: string | null;
  pageLimit?: number;
  pageNumber?: number;
  orderId?: string | null;
}

export interface OrderListApiResponse {
  orderList: OrderListData[];
  config: OrderTableColConfig[];
  pageLimit: number;
  pageNumber: number;
  totalCount: number;
}

export interface CompanyListApiResponse {
  companyList: CompanyList[];
}

export interface CompanyList {
  companyName: string;
  companyKey: string;
}

export interface UserListApiResponse {
  userList: UserList[];
}

export interface UserList {
  userFullName: string;
  userName: string;
  userId: string;
}

export interface OrderTableColDef {
  key: string;
  isEnabled: boolean;
  headerText: string;
  textAlign: 'start' | 'center' | 'end';
  template: TemplateRef<any>;
  pipe?: any;
  pipeArgs?: string[];
}

export interface ActiveOrder {
  city: string;
  companyKey: string;
  comparableCount: number;
  createdOn: Date;
  createdUser: string;
  currentUser: string;
  currentUserName: string;
  id: string;
  index: number;
  migratedFromMCA: boolean;
  opinionatedMarketValue: number;
  orderId: string;
  permittedActions: Array<OrderPermission>;
  reportType: string;
  salesComparisonValue: number;
  selectedComparableCount: number;
  state: string;
  status: string;
  streetAddress: string;
  zip: string;
}

export interface WorkflowPanelListApiResponse {
  panelList: WorkflowPanel[];
}

export interface WorkflowPanel {
  id: number;
  name: string;
  panelStatus: 'ACTIVE' | 'DRAFT';
}

export interface WorkflowPanelUserListApiResponse {
  users: {
    content: WorkflowPanelUser[];
  };
}

export interface WorkflowPanelUser {
  email: string;
  firstName: string;
  lastName: string;
  status: 'ACTIVE' | 'INACTIVE';
}
